import extend from "@/common/utils/extend-vue-app";
import { getUserId, getToken } from "@/common/cookies";

export default defineNuxtPlugin(async (nuxtApp) => {
  // 在Nuxt4中，我们使用nuxtApp来访问应用实例
  const { $store } = useNuxtApp();

  // 等待应用挂载完成
  await nuxtApp.hook("app:mounted", () => {
    const userId = getUserId();
    const token = getToken();
    console.log("fetch, mounted", userId, token);

    if (token && userId && $store) {
      $store.dispatch("user/getUserInfo", {
        user_id: userId,
      });
    }
  });
});
